var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-tabs",
        {
          attrs: {
            hideAdd: true,
            type: "editable-card",
            tabBarStyle: {
              background: "#FFF",
              margin: 0,
              paddingLeft: "16px",
              paddingTop: "1px"
            }
          },
          on: { edit: _vm.onEdit },
          model: {
            value: _vm.activeKey,
            callback: function($$v) {
              _vm.activeKey = $$v
            },
            expression: "activeKey"
          }
        },
        _vm._l(_vm.pages, function(page) {
          return _c(
            "a-tab-pane",
            {
              key: page.fullPath,
              attrs: { closable: _vm.fullPathList.length > 1 }
            },
            [
              _c(
                "a-dropdown",
                {
                  attrs: { slot: "tab", trigger: ["contextmenu"] },
                  slot: "tab"
                },
                [
                  _c(
                    "span",
                    { staticStyle: { "{ userSelect": "'none' }" } },
                    [
                      page.meta.icon
                        ? _c("a-icon", { attrs: { type: page.meta.icon } })
                        : _vm._e(),
                      _vm._v(" " + _vm._s(page.meta.title) + " ")
                    ],
                    1
                  ),
                  _vm.fullPathList.length > 1
                    ? _c(
                        "a-menu",
                        {
                          attrs: { slot: "overlay" },
                          on: { click: _vm.onMenuClose },
                          slot: "overlay"
                        },
                        [
                          _c(
                            "a-menu-item",
                            {
                              key: "close-that",
                              attrs: { "data-path": page.fullPath }
                            },
                            [
                              _c("a-icon", { attrs: { type: "close-circle" } }),
                              _vm._v("关闭当前标签 ")
                            ],
                            1
                          ),
                          _c(
                            "a-menu-item",
                            {
                              key: "close-right",
                              attrs: { "data-path": page.fullPath }
                            },
                            [
                              _c("a-icon", {
                                attrs: { type: "vertical-left" }
                              }),
                              _vm._v("关闭右侧 ")
                            ],
                            1
                          ),
                          _c(
                            "a-menu-item",
                            {
                              key: "close-left",
                              attrs: { "data-path": page.fullPath }
                            },
                            [
                              _c("a-icon", {
                                attrs: { type: "vertical-right" }
                              }),
                              _vm._v("关闭左侧 ")
                            ],
                            1
                          ),
                          _c(
                            "a-menu-item",
                            {
                              key: "close-all",
                              attrs: { "data-path": page.fullPath }
                            },
                            [
                              _c("a-icon", { attrs: { type: "close" } }),
                              _vm._v("关闭其它 ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }